<template>
  <question-group headline="Vocab">
    <visual-vocab :model="blast.vocabQuestion" :respondable="blast.isOpen || blast.isPreview" />
  </question-group>
</template>

<script>

  import sidebar from "./sidebar.js"
  import VisualVocab from "@/components/VisualVocab"

  export default {
    name: 'vocab',
    mixins: [sidebar],
    components: { VisualVocab }
  }
</script>



// WEBPACK FOOTER //
// src/components/BlastStudent/sidebar/vocab.vue